import { Fragment } from 'react';
import FormattedPrice from '../Utilities/FormattedPrice';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import { LEFT_GRID_SIZE, RIGHT_GRID_SIZE } from '../../constants/Sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TaxesAndFees = ({
  adjustments,
  currencyCode
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: adjustments.map(adjustment => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: LEFT_GRID_SIZE,
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h6",
          textAlign: "start",
          children: adjustment.label
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        marginBlockStart: "200",
        "data-test-id": "checkout-taxes-and-fees--amount",
        size: RIGHT_GRID_SIZE,
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "end",
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedPrice, {
            currencyCode: currencyCode,
            price: adjustment.amount
          })
        })
      })]
    }, `${adjustment.label}-${adjustment.adjustmentType}`))
  });
};
export default TaxesAndFees;